// Redirecting to MessagesDashboard for the new design
import MessagesDashboard from '../MessagesDashboard';

export default MessagesDashboard;
